import { asText } from '../../../../components/NaturaOps/JsonBlock'

const DASH = '—'

// One pasteable block for the Natura ticket. The operator should never have to copy
// five fields, a line list and two payloads separately and reassemble them by hand.
export const buildTicketText = (data, t) => {
  const label = key => t(`natura_operations.picking.${key}`)

  const lines = []

  // Without the verdict a refusal pastes as a success: Natura still received the POST,
  // so `delivery` alone reads "Chegou na SAP" with nothing saying it failed.
  // The platform's `message` is deliberately not copied: on the no-response path it is
  // a raw Ruby exception string, and this block leaves Cubbo.
  if (data.delivery || data.error) {
    lines.push(label(data.error ? `outcome_${data.error}` : 'outcome_accepted'), '')
  }

  lines.push(
    `${label('field_order_id')}: ${data.order_id ?? DASH}`,
    `${label('field_order_number')}: ${data.order_number || DASH}`,
    `${label('field_status')}: ${data.status || DASH}`,
    `${label('field_store')}: ${data.store_name || DASH}${data.store_id ? ` (id ${data.store_id})` : ''}`,
    `${label('field_path')}: ${data.request?.path || DASH}`,
  )

  if (data.delivery) {
    lines.push(`${label('field_delivery')}: ${label(`delivery_${data.delivery}`)}`)
  }

  // The removed lines are the whole point of a mode-2 resend: a ticket that shows the
  // payload without saying which lines were dropped is missing the operator's decision.
  const excluded = data.excluded_deliv_items || []
  lines.push(`${label('field_removed_lines')}: ${excluded.length > 0 ? excluded.join(', ') : label('no_lines_removed')}`)

  // A correction is a removal plus a replacement, so removals alone read as a shorter
  // confirmation. The lot flag travels with it: an unknown lot is what Natura rejects at
  // invoicing after a 200 here, and that is the line the ticket exists to ask about.
  const corrected = data.added_entries || []
  if (corrected.length > 0) {
    lines.push(`${label('added_heading')}:`)
    corrected.forEach(item => {
      const flag = item.lot_known === false ? ` ${label('lot_unknown_flag')}` : ''
      lines.push(
        `  ${item.deliv_item} - ${label('column_sku')} ${item.sku}, ${label('column_batch')} ${item.batch}, ${label('column_quantity')} ${item.dlv_qty}${flag}`,
      )
    })
  }

  lines.push('', `--- ${label('request_heading')} ---`, asText(data.request?.body) || DASH)

  if (data.response) {
    const code = data.response.code ? ` (HTTP ${data.response.code})` : ''
    lines.push('', `--- ${label('response_heading')}${code} ---`, asText(data.response.body) || label('response_empty'))
  }

  return lines.join('\n')
}
